import type { ApiClientDeps } from '@pay-roadrunner/api-client-core';
import { parseOrThrow } from '@pay-roadrunner/api-client-core';
import type { RegionDto } from './regionsApiTypes';

export const createRegionsClient = (adapter: ApiClientDeps) => {
  const fetchImpl = adapter.fetchImpl ?? fetch;
  const base = () => `${adapter.getBaseUrl()}/api/region`;

  const fetchRegions = async () => {
    const res = await fetchImpl(base());
    return parseOrThrow<RegionDto[]>(res);
  };

  return { fetchRegions };
};

export type RegionsClient = ReturnType<typeof createRegionsClient>;
